import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'getm-promo-bottom-bar',
  templateUrl: './promo-bottom-bar.component.html',
  styleUrls: ['./promo-bottom-bar.component.scss'],
})
export class PromoBottomBarComponent implements OnInit {

  @Input() canConfirm = false;
  @Input() isLastLevel = false;
  @Input() showSummary = false;

  @Output() summaryClick = new EventEmitter<void>();
  @Output() actionClick = new EventEmitter<void>();

  constructor() { }

  ngOnInit() { }

  public onSummaryClick = () => this.summaryClick.emit();

  public onActionClick = () => this.actionClick.emit();

}
